class QuizResults extends HHBaseElement {
  constructor() {
    super();

    this.$productsGrid = this.querySelector('.js-quiz-results-products');

    this.skus = JSON.parse(atob(this.dataset.skus));
    this.variants = JSON.parse(atob(this.dataset.variants));
    this.variantsToRender = [];
  }

  connectedCallback() {
    this.setVariantsToRender();
    this.renderProducts();
  }

  setVariantsToRender() {
    const skuParam = new URLSearchParams(window.location.search).get('sku');
    if (!skuParam || !this.skus || !this.variants) return;

    this.skus.forEach((sku, index) => {
      if (sku !== skuParam) return;

      const variantList = [];
      const variantsData = this.variants[index].split('|');
      variantsData.forEach(productHandleVariantIdString => {
        const [productHandle, variantId] = productHandleVariantIdString.split(':');
        variantList.push({ productHandle, variantId });
      })
      
      this.variantsToRender = variantList;
    })
  }

  renderProducts() {
    let content = '';
    this.variantsToRender.forEach(({ productHandle, variantId }) => {
      content += `
        <product-card
          class='product-card product-card__quiz'
          product-handle='${productHandle}'
          data-id='${variantId}'
          card-size='quiz'
          hydrate
        >
        </product-card>
      `
    })

    this.$productsGrid.innerHTML = content;
  }
}

window.customElements.define('quiz-results', QuizResults)
